import { createSlice } from '@reduxjs/toolkit'
import { hasRoles } from 'utils/accessPolicy'

const initialState = {
  me: null,
  roles: [],
  permissions: [],
  primaryRole: null,
  isLocked: false,
  pinVerified: false,
  loading: false,
  loaded: false,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser(state, action) {
      const me = action.payload || {}
      state.me = me
      state.roles = Array.isArray(me.roles) ? me.roles : []
      state.permissions = Array.isArray(me.permissions) ? me.permissions : []
      state.primaryRole = me.primary_role || null
      state.isLocked = !!me.is_locked
      state.loaded = true
      state.loading = false
    },
    clearUser(state) {
      state.me = null
      state.roles = []
      state.permissions = []
      state.primaryRole = null
      state.isLocked = false
      state.pinVerified = false
      state.loaded = false
    },
    setRoles(state, action) {
      state.roles = Array.isArray(action.payload) ? action.payload : []
    },
    setPinVerified(state, action) {
      state.pinVerified = !!action.payload
    },
    setLoading(state, action) {
      state.loading = !!action.payload
    },
  },
})

export const { setUser, clearUser, setRoles, setPinVerified, setLoading } =
  authSlice.actions

export default authSlice.reducer

export const selectMe = (state) => state.auth?.me
export const selectRoles = (state) => state.auth?.roles || []
export const selectPermissions = (state) => state.auth?.permissions || []
export const selectPrimaryRole = (state) => state.auth?.primaryRole

export const hasAnyRole = (state, roles = []) => {
  return hasRoles(state.auth?.roles, roles, state.auth?.me?.is_superuser)
}
